const keys = {
  moveInDetails: {
    subtitles: {
      previousAddress: {
        alreadyMovedIn: 'What was your previous address?',
        notMovedIn: 'What is your current address?',
      },
    },
    placeholders: {
      previousAddress: '500 Avenue des Pins, Montreal',
    },
    isInternationalAddress: {
      currently: 'My current address is outside Canada',
      previously: 'My previous address is outside Canada',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
